import SessionId from '@/lib/session_id';

  export default function(){
    this.sessionId = SessionId();
  }

